import { Injectable, inject } from '@angular/core';
import { Observable, map, of } from 'rxjs';
import { ERP_REGISTRATIONS } from '../shared/graphql/registrations.query';
import { ApiEndpointsService } from './api-endpoints.service';
import { HttpClient } from '@angular/common/http';
import { ERP_RESPONSE } from '../shared/mocks/erp.mock';
import { RegistrationsResponse } from '../models/com/registrations.model';

@Injectable({
  providedIn: 'root',
})
export class ERPRegistrationService {
  private readonly http = inject(HttpClient);
  private readonly apiService = inject(ApiEndpointsService);

  /**
   * Loads the registrations needed by the ERP widget.
   */
  getRegistrations() {
    //MOCKED DATA
    //return of(ERP_RESPONSE as RegistrationsResponse)

    const endpoint = this.apiService.baseUrl;

    return this.http.post<RegistrationsResponse>(endpoint, { query: ERP_REGISTRATIONS }, { withCredentials: true }).pipe(
      map((response: RegistrationsResponse) => {
        if (response.errors?.length) {
          throw new Error(response.errors.map((error) => error.message).join(', '));
        }
        return response.data?.registrations ?? [];
      })
    );
  }
}
